// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6755 ? "premiumcarousel.637162dd" : chunkId) + "--" + {"2292":"c9874ac","3543":"7a2b4a2","3573":"f163e02","6755":"c14651f"}[chunkId] + ".css";
};